import { render, staticRenderFns } from "./Documents.vue?vue&type=template&id=131011f3&scoped=true"
import script from "./Documents.vue?vue&type=script&lang=js"
export * from "./Documents.vue?vue&type=script&lang=js"
import style0 from "./Documents.vue?vue&type=style&index=0&id=131011f3&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "131011f3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/MAIS/MAIS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('131011f3')) {
      api.createRecord('131011f3', component.options)
    } else {
      api.reload('131011f3', component.options)
    }
    module.hot.accept("./Documents.vue?vue&type=template&id=131011f3&scoped=true", function () {
      api.rerender('131011f3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Search/Headers/Documents.vue"
export default component.exports